import { getHistoricalData } from "@/_core/data/api_calls/candle_data/getHistoricalData";
import { formatDate_YMDHMS, roundDateToFloor } from "@/_core/_helpers/_helpers";
import { gatewayService } from "@/_services/gateway.service";

/**
 * Retrieves historical data + technical analysis for ETFs and then process today's data
 * @param {object} _this: context variables
 * @param {object} assetExtraParams: Contains commodity information related
 */
export function getCandleEtfs(_this, assetExtraParams) {
  const variables = {
    format: "json",
    observation_date: formatDate_YMDHMS(
      roundDateToFloor(assetExtraParams.initDate)
    ),
    etfs: assetExtraParams.etfs
  };
  return getHistoricalData(_this, {
    fetch: gatewayService.market.etfHistory,
    variables,
    source: "etf_history"
  });
}
